import { Resources } from 'constants/resources';

import { AxiosError, AxiosResponse } from 'axios';
import { axios, axiosMultipart } from 'config/axios';
import { API_PATH } from 'config/entrypoint';

export type ReconciliationMerchant = {
  id: number;
  name: string;
  alias: string;
};

export type ReconciliationProvider = {
  id: number;
  name: string;
};

const REFERENCE_PARAMS = 'groups[]=reference';

export const getReconciliationMerchants = async (): Promise<ReconciliationMerchant[]> =>
  axios
    .get(`${Resources.ReconciliationMerchants}?${REFERENCE_PARAMS}`, {
      headers: { Accept: 'application/ld+json' },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.response));

export const getReconciliationProviders = async (
  merchantAlias: string,
): Promise<ReconciliationProvider[]> =>
  axios
    .get(`${Resources.ReconciliationMerchants}/${merchantAlias}/providers?${REFERENCE_PARAMS}`, {
      headers: { Accept: 'application/ld+json' },
    })
    .then((response: AxiosResponse) => response.data['hydra:member'])
    .catch((error: AxiosError) => Promise.reject(error.response));

export type OrderStatusReconciliationJob = {
  jobId: number;
};

export const createOrderStatusReconciliationJob = async (
  data: FormData,
): Promise<OrderStatusReconciliationJob> =>
  axiosMultipart
    .post(`${Resources.OrderStatusReconciliation}/jobs`, data)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));

export const getOrderStatusReconciliationJobResult = async (fileUrl: string): Promise<Blob> =>
  axios
    .get(new URL(fileUrl, API_PATH).href, {
      headers: { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
      responseType: 'blob',
    })
    .then((response: AxiosResponse<Blob>) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
